interface ProgressBarProps {
  /** Progress percentage from 0 to 100. */
  progress: number;

  /** Fill color of the bar. */
  fillColor?: string;

  /** Height of the bar. */
  height?: number;
}

export function ProgressBar({
  progress,
  fillColor,
  height = 2.5,
}: ProgressBarProps) {
  if (progress > 100) {
    progress = 100;
  }
  return (
    <div className={`w-full bg-neutral-400 rounded-full`} style={{ height }}>
      <div
        className={`rounded-full`}
        style={{ height, width: `${progress}%`, backgroundColor: fillColor }}
      ></div>
    </div>
  );
}
